import { render, staticRenderFns } from "./DictPositionSalaryListPage.vue?vue&type=template&id=9db1a198&"
import script from "./DictPositionSalaryListPage.vue?vue&type=script&lang=ts&"
export * from "./DictPositionSalaryListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports